import React from 'react';

import {
  Container,
  ContentContainer,
  ImageContainer,
} from './styledComponents';

type Props = {
  children: React.ReactNode;
  contentWidth?: string;
};

const AuthImageContainerUi: React.FC<Props> = ({ children, contentWidth }) => (
  <Container>
    <ContentContainer contentWidth={contentWidth}>{children}</ContentContainer>
    <ImageContainer />
  </Container>
);

export const AuthImageContainer = React.memo(AuthImageContainerUi);
